import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import classNames from 'classnames';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  counter: {
    zIndex: 3,
  },
  counterContainer: {
    alignContent: 'center',
    alignItems: 'center',
    color: 'white',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    position: 'absolute',
    top: '0',
    width: '100%',
    zIndex: 1,
  },
  overlay: {
    background: 'var(--overlay-background)',
  },
}));

type ChildrenRenderFn = (countdown: number) => React.ReactNode;

interface Props {
  children?: React.ReactNode | ChildrenRenderFn;
  time: number;
}

const CountDownTimer: React.FC<Props> = (props: Props): JSX.Element => {
  const { children, time = 0 } = props;

  const classes = useStyles();
  const [counter, setCounter] = useState(time);

  useEffect(() => {
    let timeout: NodeJS.Timeout;
    if (counter > 1) {
      timeout = setTimeout(() => setCounter(counter - 1), 1000);
    }

    return () => {
      clearTimeout(timeout);
    };
  }, [counter]);

  if (typeof children === 'function') {
    return children(counter);
  }

  return (
    <Box className={classes.counterContainer}>
      <Box className={classNames(classes.counterContainer, classes.overlay)} />
      <Typography variant="h2" className={classes.counter}>
        {counter}
      </Typography>
    </Box>
  );
};

export default CountDownTimer;
